import { ref } from 'vue';
import _ from 'lodash';
import { createSharedComposable } from '@vueuse/core';
import { CommonApis } from '@eureka/services/src/apis/common.api';
import type { IAmountItem } from '@eureka/services/src/apis/common.api.types';

export const useUsageAmount = createSharedComposable(() => {
    const usageAmount = ref<Record<string, IAmountItem>>({});
    const isUsageAmountReady = ref(false);

    async function fetchUsageAmount() {
        isUsageAmountReady.value = false;
        const res = await CommonApis.getUsageAmount();
        usageAmount.value = _.reduce(res, (acc, item) => ({
            ...acc,
            [item.key]: item,
        }), {} as Record<string, IAmountItem>);
        isUsageAmountReady.value = true;
    }

    return {
        usageAmount,
        fetchUsageAmount,
        isUsageAmountReady,
    }
})
